/* eslint-disable */
/// This file is auto generated - do not edit manually
export const DisclaimerLink = 'Website.Basket.DeliveryFix.DisclaimerLink';
export const ModalHeading = 'Website.Basket.DeliveryFix.ModalHeading';
export const ClickAndCollectTabTitle = 'Website.Basket.DeliveryFix.ClickAndCollectTabTitle';
export const ClickAndCollectStoresHeading = 'Website.Basket.DeliveryFix.ClickAndCollectStoresHeading';
export const SingleClickAndCollectStoreHeading = 'Website.Basket.DeliveryFix.SingleClickAndCollectStoreHeading';
export const ClickAndCollectNoStores = 'Website.Basket.DeliveryFix.ClickAndCollectNoStores';
export const OnlineDeliveryTabTitle = 'Website.Basket.DeliveryFix.OnlineDeliveryTabTitle';
export const OnlineDeliveryHeading = 'Website.Basket.DeliveryFix.OnlineDeliveryHeading';
export const OnlineDeliveryNoOption = 'Website.Basket.DeliveryFix.OnlineDeliveryNoOption';
export const CancelButton = 'Website.Basket.DeliveryFix.CancelButton';
export const ContinueButton = 'Website.Basket.DeliveryFix.ContinueButton';
export const DeleteProductItemsButton = 'Website.Basket.DeliveryFix.DeleteProductItemsButton';
export const SoldOutOnlineText = 'Website.Basket.DeliveryFix.SoldOutOnlineText';
export const SoldOutOnlineButtonText = 'Website.Basket.DeliveryFix.SoldOutOnlineButtonText';
export const NoDeliveryTabSelected = 'Website.Basket.DeliveryFix.NoDeliveryTabSelected';
